import React, { useEffect, useState } from "react";
import {Amplify, API, Auth, Cache} from 'aws-amplify';
import { Signer } from '@aws-amplify/core';

const StripeAccount = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTransactions = async () => {
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            const { attributes } = cognitoUser;
            const payload = cognitoUser.signInUserSession?.idToken?.payload || {};
            const email = attributes?.email || payload?.email;
            if (!email) {
              throw new Error("Email not available from Cognito user attributes or token payload.");
            }

            const credentials = await Auth.currentCredentials();

            const endpoint = "https://b7wsvlecdkm5iz4ptn2dcha6ta0yyfvs.lambda-url.us-east-1.on.aws/";
            const emailPayload = JSON.stringify({ email });
            const serviceInfo = {
              service: 'lambda',
              region: 'us-east-1'
            };

            const signedRequest = await Signer.sign(
              {
                url: endpoint,
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                data: emailPayload,
              },
              {
                access_key: credentials.accessKeyId,
                secret_key: credentials.secretAccessKey,
                session_token: credentials.sessionToken,
              },
              serviceInfo
            );
            
            const response = await fetch(signedRequest.url, {
              method: "POST",
              headers: signedRequest.headers,
              body: emailPayload,
            });

            const data = await response.json();
            setTransactions(data.invoices || []);
        } catch (error) {
            console.error("Error fetching transactions:", error);
        } finally {
            setLoading(false);
        }
    };

    fetchTransactions();
  }, []);

  if (loading) return (
    <p
    style={{
        display: "flex",
        justifyContent: "center", // Centers horizontally
        alignItems: "center", // Centers vertically
        height: "100vh", // Takes full viewport height for vertical centering
        width: "100%", // Ensures full width
      }}
    >
      Loading data. Please wait...
    </p>
  );

  const handleChangePlan = async () => {
    try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const { attributes } = cognitoUser;
        const payload = cognitoUser.signInUserSession?.idToken?.payload || {};
  
        const email = attributes?.email || payload?.email;
        if (!email) {
          throw new Error("Email not available from Cognito user attributes or token payload.");
        }

        const credentials = await Auth.currentCredentials();

        const endpoint = "https://up2od7jkhlpddeb2bb4zcjmzgi0dhizs.lambda-url.us-east-1.on.aws/";
        const emailPayload = JSON.stringify({ email });
        const serviceInfo = {
          service: 'lambda',
          region: 'us-east-1'
        };

        const signedRequest = await Signer.sign(
          {
            url: endpoint,
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            data: emailPayload,
          },
          {
            access_key: credentials.accessKeyId,
            secret_key: credentials.secretAccessKey,
            session_token: credentials.sessionToken,
          },
          serviceInfo
        );
        
        const response = await fetch(signedRequest.url, {
          method: "POST",
          headers: signedRequest.headers,
          body: emailPayload,
        });

        const data = await response.json();
        window.location.href = data.billingPortalUrl; // Redirects user to Billing Portal
    } catch (error) {
        console.error("Error changing payment method:", error);
    }
};

  return (
    <div style={{ width: "100%",maxWidth: "100%", margin:"20px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <span style={{
        fontFamily: "Inter",
        fontSize: "32px",
        fontWeight: 500,
        color: "rgb(13, 26, 38)",
        lineHeight: "40px",
        textAlign: "left",
        display: "block",
        flexDirection: "column",
        justifyContent: "unset",
        width: "unset",
        height: "unset",
        gap: "unset",
        alignItems: "unset",
        flexShrink: 0,
        position: "relative",
        padding: "0px",
        whiteSpace: "pre-wrap",
      }}>Account Management</span>
        <button onClick={handleChangePlan} style={{ padding: "10px 20px", fontSize: "16px", border: "0", cursor: "pointer", borderRadius: "5px",
          color: "white",
          backgroundColor: "#007899",}}>Change Plan</button>
      </div>
      
      <br/>
      <table border="1" cellPadding="10" style={{ width: "100%",maxWidth: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Invoice</th>
          </tr>
        </thead>
        <tbody>
          {transactions.length > 0 ? (
            transactions.map((invoice) => (
              <tr key={invoice.id}>
                <td>{new Date(invoice.created * 1000).toLocaleDateString()}</td>
                <td>${(invoice.amount_due / 100).toFixed(2)}</td>
                <td>{invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)}</td>
                <td>
                  <a href={invoice.hosted_invoice_url} target="_blank" rel="noopener noreferrer">
                    View Invoice
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                No transactions found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StripeAccount;
